function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 12.8,
  fill: "#EDF8EC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.814 22.59a3.37 3.37 0 00.573-1.884A3.392 3.392 0 0032 17.317a3.392 3.392 0 00-3.388 3.389c0 .696.212 1.345.573 1.884a5.65 5.65 0 00-2.832 4.892v3.388h11.294v-3.388a5.65 5.65 0 00-2.832-4.892zm-3.944-1.884a1.13 1.13 0 012.259 0 1.13 1.13 0 01-2.26 0zm4.517 7.905h-6.776v-1.129a3.392 3.392 0 013.388-3.388 3.392 3.392 0 013.388 3.388v1.13z",
  fill: "#22A518"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.367 42.92a3.37 3.37 0 00.574-1.885 3.392 3.392 0 00-4.724-3.113l-3.532-3.825a12.386 12.386 0 003.738-8.874C44.423 18.373 38.85 12.8 32 12.8s-12.424 5.573-12.424 12.423c0 3.473 1.433 6.617 3.738 8.874l-3.53 3.825a3.392 3.392 0 00-4.725 3.113c0 .697.211 1.345.573 1.884a5.65 5.65 0 00-2.832 4.893V51.2h11.294v-3.388a5.65 5.65 0 00-2.832-4.893 3.378 3.378 0 00.18-3.464l3.625-3.927A12.353 12.353 0 0032 37.647c2.565 0 4.951-.782 6.932-2.12l3.625 3.928a3.378 3.378 0 00.181 3.464 5.65 5.65 0 00-2.832 4.893V51.2H51.2v-3.388a5.65 5.65 0 00-2.833-4.893zM21.835 48.94H15.06v-1.13a3.392 3.392 0 013.388-3.388 3.392 3.392 0 013.388 3.389v1.129zm-4.518-7.906a1.13 1.13 0 012.26 0 1.13 1.13 0 01-2.259 0zm4.518-15.812c0-5.604 4.56-10.164 10.165-10.164 5.605 0 10.164 4.56 10.164 10.164 0 5.605-4.56 10.165-10.164 10.165-5.605 0-10.165-4.56-10.165-10.165zm22.588 15.812a1.13 1.13 0 012.26 0 1.13 1.13 0 01-2.259 0zm4.518 7.906h-6.777v-1.13a3.392 3.392 0 013.389-3.388 3.392 3.392 0 013.388 3.389v1.129z",
  fill: "#22A518"
});

var SvgReportTasks = function SvgReportTasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgReportTasks;